export const s3config = {
    bucketName:  process.env.REACT_APP_S3_BUCKET || "",
    region: process.env.REACT_APP_S3_REGION || "",
    accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY || "",
    secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY || ""
};
